module.exports = __webpack_public_path__ + "img/yes.ea497ae8.png";